// extracted by mini-css-extract-plugin
export default {"root":"WorkspaceMembers_root__k5zRZ"};